import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js'; // Importa el contexto

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user } = useContext(LoginContext);

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated || !user) {
    return <Navigate to="/" />;
  }

  // Si está autenticado, renderiza los componentes hijos
  return children;
};

export default ProtectedRoute;
